import React, { memo } from 'react';
import { injectIntl } from 'react-intl';
import { Card, CardHeader, CardContent, Divider, Grid, Typography } from '@mui/material';
import SpeedIcon from '@mui/icons-material/Speed';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { LineChart, Line, ResponsiveContainer } from 'recharts';
import { getChartColors } from '../../../../utils/chartTheme';

// Uma redução no tempo (espera/atendimento/resolução) é uma melhora — por isso o ícone
// de tendência aqui é invertido em relação ao KpiCard (queda = verde, alta = vermelho).
const PerformancePanel = memo(function PerformancePanel(props) {
  const { intl, metrics } = props;
  const colors = getChartColors();

  return (
    <Card style={{ height: '100%' }}>
      <CardHeader
        avatar={<span style={{ color: colors.primary, display: 'flex' }}><SpeedIcon /></span>}
        title={intl.formatMessage({ id: 'agentproductivity.dashboard.performance.title', defaultMessage: 'Performance' })} />
      <Divider />
      <CardContent>
        {(metrics || []).map((metric, index) => {
          const improved = metric.comparation != null ? metric.comparation <= 0 : null;
          return (
            <Grid container key={`performance-row-${index}`} alignItems="center" style={{ marginBottom: 18 }}>
              <Grid item xs={7}>
                <Typography variant="body2" color="textSecondary">{metric.label}</Typography>
                <Typography variant="h5">{metric.value}</Typography>
              </Grid>
              <Grid item xs={3}>
                {metric.series && metric.series.length > 0 && (
                  <div style={{ height: 32 }}>
                    <ResponsiveContainer width="100%" height="100%">
                      <LineChart data={metric.series}>
                        <Line
                          type="monotone"
                          dataKey="value"
                          stroke={improved ? colors.success : colors.error}
                          strokeWidth={2}
                          dot={false}
                          isAnimationActive={false}
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                )}
              </Grid>
              <Grid item xs={2}>
                {metric.comparation != null && (
                  <Grid container alignItems="center" justifyContent="flex-end">
                    {improved ? (
                      <ArrowDownwardIcon fontSize="small" style={{ color: 'green' }} />
                    ) : (
                      <ArrowUpwardIcon fontSize="small" color="error" />
                    )}
                    <Typography variant="body2" style={{ color: improved ? 'green' : undefined }} color={improved ? undefined : 'error'}>
                      {Math.abs(metric.comparation)}%
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </Grid>
          );
        })}
        <Typography variant="caption" color="textSecondary" component="div">
          {intl.formatMessage({ id: 'agentproductivity.dashboard.performance.subtitle', defaultMessage: 'Dados referentes ao período selecionado' })}
        </Typography>
        <Typography variant="caption" color="textSecondary" component="div">
          {intl.formatMessage({ id: 'agentproductivity.dashboard.performance.comparisonlegend', defaultMessage: 'A porcentagem compara com o período anterior de mesma duração.' })}
        </Typography>
      </CardContent>
    </Card>
  );
});

export default injectIntl(PerformancePanel);
